<template>
    <div class="waterfall-height-css" id="loadmore">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="-----我们是有底线的-----"
        @load="onLoad"
      >
        <Waterfall
          :minCol="2"
          :maxCol="2"
          :percent="[1,1]"
          :gutterHeight="10"
          :width="itemWidth"
          :gutterWidth="gutterWidth"
        >
          <div
            class="margin"
            v-for="(item,index) in dataList"
            :key="index"
            :class="{'toMargin':item.type=='water'}"
            v-gioShow
            :item="item"
            :index="index"
            :style="bgColor"
          >
            <div class="item-content" @click="toComodity(item)">
              <div class="item-block" :class="{'noMargin':item.type=='water'}">
                 <img v-lazy="funImg(item)" fit="contain" class="index-title-image" lazy-progressive/>
                <!-- <van-image :src="funImg(item)" fit="cover" lazy-load :show-loading='false'/> -->
              </div>
              <div
                class="card-content van-multi-ellipsis--l2"
                v-show="item.type!='water'"
              >{{item.itemName}}</div>
              <div class="card-footer" v-show="item.type!='water'">
                <p class="color">￥{{item.price}}</p>
                <p class="color-cc">￥{{item.markingPrice}}</p>
              </div>
            </div>
            <div
              class="footer van-hairline--top"
              @click="toBrand(item)"
              v-show="item.type!='water'"
            >
              <img src="@/assets/image/shop.png" />
              <p class="van-ellipsis">{{item.branchName}}</p>
            </div>
          </div>
        </Waterfall>
      </van-list>
    </div>
</template>
<script>
import { Waterfall } from "vue2-waterfall";
import http from "@/utils/axios";
import utils from "@/utils/common";
export default {
  data() {
    return {
      loading: false,
      finished: false,
      dataList: [],
      ids: [],
      pageIndex: 0
    };
  },
  props: {
    refresh: {
      default: false,
      type: Boolean
    },
    goodssId: {
      default: "",
      type: Number
    },
    activity: {
      default: function() {
        return {};
      },
      type: Object
    },
    goodss: {
      default: function() {
        return [];
      },
      type: Array
    },
    active: {
      default: -1,
      type: Number
    },
    title:{
      default:'推荐',
      type:String
    },
    activeStatus: {
      default: true,
      type: Boolean
    },
    bgColor: {
      default: '',
      type: String
    }
  },
  methods: {
    // 去商品
    toComodity(item) {
      if (item.type == "water") {
        if (item.waterLinkType === "BRANCH") {
          this.toBrand({branchNo: item.waterLinkId});
        } else if (item.waterLinkValue && item.waterLinkType === "LINK") {
          utils.jumpUrl(item.waterLinkValue);
        } else if (item.waterLinkType === "SHOP") {
          this.$router.push({
            path: "/markentindex",
            query: { id: item.waterLinkId }
          });
        } else if (item.waterLinkType === "GOODS") {
          gio('track', 'productClick', {productName_var:item.itemName,productID_var:item.waterLinkId});
          var obj = {goodsId:parseInt(item.waterLinkId)};
           utils.jumpToNewPage({
              url: window.location.origin + "/h5user/commoditydetails?id=" + item.waterLinkId,
              noTitle: "0",
              action:{tm:"4030100",tp:obj}
           });
          // this.$router.push({
          //   path: "/commoditydetails",
          //   query: { id: item.waterLinkId }
          // });
        }
        let parmes={
          id:item.waterLinkId,
          entryPage:'广告位'
        }
        this.gioFun(parmes);
      } else {
        let parmes={
          id:item.id,
          entryPage:'HOME_PAGE',
          entryType:'CATEGORY_RECOMMEND'
        }
        this.gioFun(parmes);
        gio('track', 'flowLocationClick', {positonName_var: item.itemName, sort_var: item.categoryName, entryType_vara: '商品推荐'})
        // this.$router.push({
        //   path: "/commoditydetails",
        //   query: { id: item.id }
        // });
        var obj = {goodsId:parseInt(item.id)};
         utils.jumpToNewPage({
              url: window.location.origin + "/h5user/commoditydetails?id=" + item.id,
              noTitle: "0",
              action:{tm:"4030100",tp:obj}
           });
      }
    },
    toBrand(branch) {
      branch.branchName && gio('track', 'flowLocationClick', {positonName_var: branch.branchName, sort_var: branch.categoryName, entryType_vara: '商品推荐'})
      this.$router.push({ path: "/brandindex", query: { brandId: branch.branchNo } });
    },
    getDate() {
      let _this = this;
      let water = {};
      if (this.active == -1 && this.ids.length === 0 && this.activity.waterLink) {
        this.dataList = [];
        water = {
          indexImage: {
            imageUrl: this.activity.waterLink.imageUrl
          },
          type: "water",
          waterLinkValue: this.activity.waterLinkValue,
          waterLinkType: this.activity.waterLinkType,
          waterLinkId: this.activity.waterLinkId
        };
      }
      http({
        url: "base/user/join/indexGoods",
        method: "post",
        parmes: { ids: this.ids }
      }).then(rps => {
        if (rps.code == 200) {
          if (rps.data.length != 0) {
            rps.data.forEach((item, index) => {
              if (index == 1 && _this.ids.length == 1 && _this.activeStatus) {
                _this.dataList.push(water);
              }
              _this.dataList.push(item);
              _this.ids.push(item.id);
            });
            this.loading = false;
          } else {
            this.finished = true;
          }
        }
      });
    },
    getItemData() {
      http({
        url: "item/app/item/page",
        method: "post",
        parmes: {
          categoryId: this.goodssId,
          pageIndex: this.pageIndex,
          pageSize: "20"
        }
      }).then(rps => {
        if (rps.code == 200) {
          if (rps.data.length != 0) {
            rps.data.forEach(item => {
              this.dataList.push(item);
            });
            this.loading = false;
          } else {
            if (rps.data.length === 0 && this.pageIndex == 1) {
              this.loading = false;
            } else {
              this.finished = true;
            }
          }
        }
      });
    },
    onLoad() {
      if (this.goodssId != "-1") {
        this.pageIndex++;
        this.getItemData();
      } else {
        this.getDate();
      }
    },
    funImg(item) {
      if (item.indexImage && item.indexImage.imageUrl) {
        return (
          item.indexImage.imageUrl + "?x-oss-process=style/style_index_list_img"
        );
      }
    }
  },
  computed: {
    itemWidth() {
      return 133 * 0.5 * (document.documentElement.clientWidth / 375);
    },
    gutterWidth() {
      return 10 * 0.5 * (document.documentElement.clientWidth / 375);
    }
  },
  watch: {
    refresh: function(val) {
      if(val) {
        this.loading = false
        this.finished = false
        this.dataList = []
        this.ids = []
        this.onLoad()
      }
    }
  },
  components: { Waterfall }
};
</script>
<style scoped lang="less">
.waterfall-height-css {
  // border: 1px solid rgba(242, 242, 242, 1);
  padding: 20px 20px;
  // min-height: 1334px;
  .toMargin {
    margin-bottom: 20px !important;
    border: 0 !important;
  }
  .margin {
    margin: 10px 10px 20px 10px;
    border-radius: 10px;
    border: 1PX solid #f2f2f2;
    .noMargin {
      margin-bottom: 0 !important;
    }
  }
  .item-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #686868;
    box-sizing: border-box;
    .item-block {
      border: none;
      border-radius: 0.1rem;
      overflow: hidden;
      position: relative;
      margin: 0 0 10px 0;
      background-color: #fff;
      width: 100%;
      max-height: 400px;
      .van-image{
        position: initial;
      }
      img {
        width: 100%;
      }
    }
    .card-content {
      padding: 0 20px;
      width: 100%;
      box-sizing: border-box;
      font-size: 24px;
    }
    .card-footer {
      min-height: 44px;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 10px 20px;
      .color {
		font-weight: bold;
        color: #e83636;
        font-size: 26px;
      }
      .color-cc {
        color: #ccc;
        font-size: 22px;
        text-decoration: line-through;
      }
    }
  }
  .index-title-image[lazy=loaded]{
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation-name: fadeIn;
    animation-name: fadeIn;
  }
  .footer {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
    padding-top: 24px;
    img {
      width: 32px;
      height: 32px;
      padding: 0 10px 0 20px;
    }
    p {
      color: #999;
      flex: 1;
      font-size: 22px;
    }
  }
}
</style>